
import { MediaOwnerPricingConstants, MediaOwnerType } from './types';
import { tableAdsPricingConstants } from './tableAds';
import { alanPricingConstants } from './alan';
import { wakiPricingConstants } from './waki';
import { attentionPricingConstants } from './attention';

// Helper function to determine the media owner from a location name
export const getMediaOwnerFromLocationName = (locationName: string): MediaOwnerType => {
  if (!locationName) return 'Alan';
  
  if (locationName.toLowerCase().includes('alan')) {
    return 'Alan';
  }
  
  if (locationName.toLowerCase().includes('waki')) {
    return 'Waki';
  }
  
  if (locationName.toLowerCase().includes('attention')) {
    return 'Attention';
  }
  
  return 'Alan';
};

// Helper to get pricing constants based on media owner
export const getPricingConstants = (mediaOwner: string): MediaOwnerPricingConstants => {
  switch (mediaOwner) {
    case 'Alan':
      return alanPricingConstants;
    case 'Waki':
      return wakiPricingConstants;
    case 'Attention':
      return attentionPricingConstants;
    default:
      return alanPricingConstants;
  }
};

// Re-export for backward compatibility
export * from './types';
export * from './tableAds';
export * from './alan';
export * from './waki';
export * from './attention';
